import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/master-user?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/master-user', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/master-user/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/master-user/${body.id}`, body.body);
};
export const GET_DETAIL = (id) => {
    return axiosIns.get(`/master-user/${id}`);
};
export const CREATE_DATA_VALIDATION = (body) => {
    return axiosIns.post('/master-user/validasi-create', body);
};


